// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getIsInternationalShipping,
  getIsNewLoyaltyBanner,
  getIsPersistPointsApiEnabled,
  getIsPDPRedesignEnabled,
  getPlccOfferPercentage,
  getIsPLCCApplyNowWithSaveBtnAndLearnMoreLinkEnabled,
  getIsPLCCApplyNowBtnAndLearnMoreBtnEnabled,
  getIsPLCCApplyNowBtnAndLearnMoreLinkEnabled,
  getIsLoyaltyTieringEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary';
import { getCurrencySymbol } from '@tcp/core/src/components/features/CnC/common/organism/OrderLedger/container/orderLedger.selector';
import { openOverlayModal } from '@tcp/core/src/components/features/account/OverlayModal/container/OverlayModal.actions';
import { toggleApplyNowModal } from '@tcp/core/src/components/common/molecules/ApplyNowPLCCModal/container/ApplyNowModal.actions';
import { resetPLCCResponse } from '@tcp/core/src/components/features/browse/ApplyCardPage/container/ApplyCard.actions';
import { closeAddedToBag } from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.actions';
import BagPageSelector from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.selectors';
import { getUserLoggedInState } from '@tcp/core/src/components/features/account/User/container/User.selectors';
import { getEnableFullPageAuth } from '@tcp/web/src/components/features/content/HomePage/HomePage.selectors';
import { checkIsPaymentSectionSaved } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.selector';
import { ADDED_TO_BAG_PAGE } from '@tcp/web/src/components/App.constants';
import LoyaltyBannerView from '../views/LoyaltyBannerView';
import {
  getThresholdValue,
  cartOrderDetails,
  confirmationDetails,
  getFooterLabels,
} from './LoyaltyBanner.selectors';
import CheckoutSelectors, { isGuest } from '../../Checkout/container/Checkout.selector';
import { isPlccUser } from '../../../account/User/container/User.selectors';
import { setPageCategoryData } from '../../../../../analytics/actions';
import { getPLCCDiscountValue } from '../../../../common/organisms/Promotions/container/Promotions.selectors';

export const LoyaltyBannerContainer = ({
  bagLoading,
  orderDetails,
  isCartEmpty,
  thresholdValue,
  isGuestCheck,
  isPlcc,
  currencySymbol,
  pageCategory,
  isInternationalShipping,
  openOverlay,
  closeAddedToBagModal,
  inheritedStyles,
  openApplyNowModal,
  footerLabels,
  navigation,
  cartOrderItems,
  isUserLoggedIn,
  resetTimerStatus,
  clickAnalyticsData,
  isCompleteTheLookTestEnabled,
  showFullPageAuth,
  spc,
  isFancyBanner,
  isNewLoyaltyBanner,
  isOptmisticAddToBagModal,
  isLoyalityCallCompleted,
  isPaymentSectionSaved,
  newMiniBag,
  isAddedToBagRedesign,
  isLoyaltyPointsEnabled,
  isPDPRedesignEnabled,
  isLoyaltyTieringEnabled,
  openModalLearnMore,
  isSecondaryLoyaltyComponentEnabledApp,
  plccOfferPercentage,
  isPLCCApplyNowBtnAndLearnMoreBtnEnabled,
  isPLCCApplyNowBtnAndLearnMoreLinkEnabled,
  isPLCCApplyNowWithSaveBtnAndLearnMoreLinkEnabled,
}) => {
  const {
    estimatedRewards,
    subTotal,
    subTotalWithDiscounts,
    cartTotalAfterPLCCDiscount,
    earnedReward,
    pointsToNextReward,
  } = orderDetails;
  const plccOfferPercentageValue = (100 - (plccOfferPercentage || 30)) / 100;
  const plccProductOfferPrice = subTotal * (plccOfferPercentageValue || 0.7);
  return (
    <LoyaltyBannerView
      isUserLoggedIn={isUserLoggedIn}
      estimatedRewardsVal={estimatedRewards}
      currentSubtotal={subTotal}
      estimatedSubtotal={plccProductOfferPrice || cartTotalAfterPLCCDiscount}
      checkThresholdValue={subTotalWithDiscounts}
      thresholdValue={thresholdValue}
      isGuest={isGuestCheck}
      earnedReward={earnedReward}
      isPlcc={isPlcc}
      pointsToNextReward={pointsToNextReward}
      getCurrencySymbol={currencySymbol}
      pageCategory={spc && isPaymentSectionSaved ? ADDED_TO_BAG_PAGE : pageCategory}
      isInternationalShipping={isInternationalShipping}
      openOverlay={openOverlay}
      closeAddedToBagModal={closeAddedToBagModal}
      inheritedStyles={inheritedStyles}
      openApplyNowModal={openApplyNowModal}
      footerLabels={footerLabels}
      navigation={navigation}
      bagLoading={bagLoading}
      isCartEmpty={isCartEmpty}
      cartOrderItems={cartOrderItems}
      resetTimerStatus={resetTimerStatus}
      setClickAnalyticsData={clickAnalyticsData}
      isCompleteTheLookTestEnabled={isCompleteTheLookTestEnabled}
      showFullPageAuth={showFullPageAuth}
      spc={spc}
      isPaymentSectionSaved={isPaymentSectionSaved}
      isFancyBanner={isNewLoyaltyBanner && isFancyBanner}
      isOptmisticAddToBagModal={isOptmisticAddToBagModal}
      isLoyalityCallCompleted={isLoyalityCallCompleted}
      newMiniBag={newMiniBag}
      isAddedToBagRedesign={isAddedToBagRedesign}
      isLoyaltyPointsEnabled={isLoyaltyPointsEnabled}
      isPDPRedesignEnabled={isPDPRedesignEnabled}
      isLoyaltyTieringEnabled={isLoyaltyTieringEnabled}
      openModalLearnMore={openModalLearnMore}
      isSecondaryLoyaltyComponentEnabledApp={isSecondaryLoyaltyComponentEnabledApp}
      plccOfferPercentage={plccOfferPercentage}
      isPLCCApplyNowBtnAndLearnMoreBtnEnabled={isPLCCApplyNowBtnAndLearnMoreBtnEnabled}
      isPLCCApplyNowBtnAndLearnMoreLinkEnabled={isPLCCApplyNowBtnAndLearnMoreLinkEnabled}
      isPLCCApplyNowWithSaveBtnAndLearnMoreLinkEnabled={
        isPLCCApplyNowWithSaveBtnAndLearnMoreLinkEnabled
      }
    />
  );
};

LoyaltyBannerContainer.propTypes = {
  labels: PropTypes.shape({}).isRequired,
  orderDetails: PropTypes.shape({
    estimatedRewards: PropTypes.string,
    subTotal: PropTypes.string,
    subTotalWithDiscounts: PropTypes.string,
    cartTotalAfterPLCCDiscount: PropTypes.string,
    earnedReward: PropTypes.string,
    pointsToNextReward: PropTypes.string,
  }).isRequired,
  closeAddedToBagModal: PropTypes.func.isRequired,
  openOverlay: PropTypes.func.isRequired,
  thresholdValue: PropTypes.number,
  isGuestCheck: PropTypes.bool,
  isPlcc: PropTypes.bool,
  currencySymbol: PropTypes.string,
  pageCategory: PropTypes.string,
  isInternationalShipping: PropTypes.bool,
  inheritedStyles: PropTypes.string,
  openApplyNowModal: PropTypes.func.isRequired,
  footerLabels: PropTypes.shape({}).isRequired,
  navigation: PropTypes.shape({}),
  bagLoading: PropTypes.bool,
  isCartEmpty: PropTypes.bool,
  cartOrderItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  isUserLoggedIn: PropTypes.bool,
  resetTimerStatus: PropTypes.func,
  clickAnalyticsData: PropTypes.func.isRequired,
  isCompleteTheLookTestEnabled: PropTypes.bool,
  showFullPageAuth: PropTypes.bool,
  spc: PropTypes.bool,
  isFancyBanner: PropTypes.bool,
  isNewLoyaltyBanner: PropTypes.bool,
  isOptmisticAddToBagModal: PropTypes.bool,
  isLoyalityCallCompleted: PropTypes.bool,
  isPaymentSectionSaved: PropTypes.bool,
  newMiniBag: PropTypes.bool,
  isLoyaltyPointsEnabled: PropTypes.bool,
  openModalLearnMore: PropTypes.func,
};

LoyaltyBannerContainer.defaultProps = {
  thresholdValue: null,
  isGuestCheck: false,
  isPlcc: false,
  currencySymbol: '',
  pageCategory: '',
  isInternationalShipping: false,
  inheritedStyles: '',
  navigation: null,
  bagLoading: false,
  isCartEmpty: false,
  isUserLoggedIn: false,
  resetTimerStatus: () => {},
  isCompleteTheLookTestEnabled: false,
  showFullPageAuth: false,
  spc: false,
  isFancyBanner: false,
  isNewLoyaltyBanner: false,
  isOptmisticAddToBagModal: false,
  isLoyalityCallCompleted: true,
  isPaymentSectionSaved: false,
  newMiniBag: false,
  isLoyaltyPointsEnabled: false,
  openModalLearnMore: () => {},
};

export const mapDispatchToProps = (dispatch) => ({
  openOverlay: (component) => dispatch(openOverlayModal(component)),
  closeAddedToBagModal: () => {
    dispatch(closeAddedToBag());
  },
  openApplyNowModal: (payload) => {
    dispatch(toggleApplyNowModal(payload));
    dispatch(resetPLCCResponse(payload));
  },
  clickAnalyticsData: (payload) => dispatch(setPageCategoryData(payload)),
});

/* istanbul ignore next */
export const mapStateToProps = (state, ownProps) => {
  return {
    orderDetails:
      ownProps.pageCategory === 'confirmation'
        ? confirmationDetails(state)
        : cartOrderDetails(state),
    thresholdValue: getThresholdValue(state),
    isGuestCheck: isGuest(state),
    isPlcc: isPlccUser(state),
    currencySymbol: getCurrencySymbol(state),
    isInternationalShipping: getIsInternationalShipping(state),
    footerLabels: getFooterLabels(state, ownProps.pageCategory),
    bagLoading: BagPageSelector.isBagLoading(state),
    cartOrderItems: BagPageSelector.getOrderItems(state),
    isUserLoggedIn: getUserLoggedInState(state),
    showFullPageAuth: getEnableFullPageAuth(state),
    isRtpsFlow: CheckoutSelectors.getIsRtpsFlow(state),
    isNewLoyaltyBanner: getIsNewLoyaltyBanner(state),
    isPaymentSectionSaved: checkIsPaymentSectionSaved(state),
    isLoyaltyPointsEnabled: getIsPersistPointsApiEnabled(state),
    isPDPRedesignEnabled: getIsPDPRedesignEnabled(state),
    isLoyaltyTieringEnabled: getIsLoyaltyTieringEnabled(state),
    plccOfferPercentage: getPLCCDiscountValue(state) || getPlccOfferPercentage(state),
    isPLCCApplyNowBtnAndLearnMoreBtnEnabled: getIsPLCCApplyNowBtnAndLearnMoreBtnEnabled(state),
    isPLCCApplyNowBtnAndLearnMoreLinkEnabled: getIsPLCCApplyNowBtnAndLearnMoreLinkEnabled(state),
    isPLCCApplyNowWithSaveBtnAndLearnMoreLinkEnabled:
      getIsPLCCApplyNowWithSaveBtnAndLearnMoreLinkEnabled(state),
  };
};

export default errorBoundary(connect(mapStateToProps, mapDispatchToProps)(LoyaltyBannerContainer));
